export const ENTITIES = {
	users: { name: "Users" },
	userOrders: { name: "Orders" },
	userGiftOrders: { name: "Gift Orders" },
	userHelpQueries: { name: "Help Queries Users" },
	restaurants: { name: "Restaurants" },
	restaurantMenuItems: { name: "Menu Items" },
	restaurantOrders: { name: "Orders" },
	restaurantGiftOrders: { name: "Gift Orders" },
	restaurantHelpQueries: { name: "Help Queries Restaurants" },
	orders: { name: "Orders" },
	giftOrders: { name: "Gift Orders" },
	promoGifts: { name: "Promo Gift" },
	promoApprovalRequests: { name: "Promo Approval Requests" },
	upcomingPayouts: { name: "Transactions" },
	payoutOrdersTable: { name: "Orders" },
	payoutsHistory: { name: "Payouts History" },
	cms: { name: "CMS" },
	emailTemplates: { name: "Email Templates" },
	brands: { name: "Brands" },
	faqCategoriesListing: { name: "FAQ Categories" },
	faqsListing: { name: "FAQ" },
	categories: { name: "Categories" },
	coupons: { name: "Coupons" },
	cuisines: { name: "Cuisines" },
	moods: { name: "Moods" },
	helpTopics: { name: "Help Topics" },
	helpQueriesUsers: { name: "Help Queries Users" },
	helpQueriesRestaurants: { name: "Help Queries Restaurants" },
	transactionHistoryUsers: { name: "Transaction History Users" },
	promotions: { name: "Promotions" },
	reports: { name: "Reports" },
	reportReasons: { name: "Report Reasons" },
	unClaimedGifts: { name: "Unclaimed Gifts" },
	referrals: { name: "Referrals" },
};
